import mutations from './mutations';
import api from '../api';
import spending from '@/api/spending';

export default {
  namespaced: true,
  state: {
    loading: false,
    budgets: [],
    status: null,
    filteredItems: []
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    },
    update(state, payload) {
      state[payload[0]] = payload[1];
    }
  },
  actions: {
    parse({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .parse(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uploadDocs({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .uploadDocs(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    edit({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .edit(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getGuideline({ commit }) {
      commit(mutations.LOADING);
      return api.spending
        .getGuideline()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    approve({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .approve(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    approveBO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .approveBO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    approveHouse({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .approveHouse(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    reject({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .reject(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    rejectBO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .rejectBO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    rejectHouse({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .rejectHouse(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    submit({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .submit(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detail({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .detail(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getProduct({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .getProduct(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    editSupportDocs({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .editSupportDocs(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    notesBO({ commit }, { id, payload }) {
      commit(mutations.LOADING);
      return api.spending
        .notesBO(id, payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    notesHouse({ commit }, { id, payload }) {
      commit(mutations.LOADING);
      return api.spending
        .notesHouse(id, payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getIO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .getIO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    uploadSAP({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .uploadSAP(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uploadPO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .uploadPoBi(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uploadIO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .uploadIoBi(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uploadNonPo({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .uploadNonPo(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    async advanceFilter(ctx, params) {
      try {
        const { data } = await spending.advanceFilter(params);
        return data.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    approveBOAdhoc({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .approveBOAdhoc(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    approveAdhoc({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .approveAdhoc(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detailProfile({ commit }, id) {
      commit(mutations.LOADING);
      return api.spending
        .detailProfile(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    addIO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .addIO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detailTaxo({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .detailTaxo(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    summaryAmount({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .summaryAmount(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getConsolidatedReport({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .getConsolidatedReport(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getDetailSpending({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .getDetailSpending(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    parseRevise({ commit }, { payload, params }) {
      commit(mutations.LOADING);
      return api.spending
        .parseRevise(payload, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    parseReviseSales({ commit }, { payload, params }) {
      commit(mutations.LOADING);
      return api.spending
        .parseReviseSales(payload, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    parseSales({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .parseSales(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    createRevise({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .createRevise(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    cancelIO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .cancelIO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uncancelIO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spending
        .uncancelIO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getProgressTracking({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spending
        .getProgressTracking(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {}
};
